/* eslint-disable */
import React, { FC, useEffect } from 'react';
import { Spin } from 'antd';
import SelectServices from '~/components/views/ServicesView/SelectServices';
import { useGetApplication } from '~/controllers/wizard';
import { Draft } from '~/types/Draft';
import { useGetDraft } from '~/controllers/draft';
import { useHistory } from 'react-router';
import paths from '~/pages/paths';
import { getStagePayload } from '~/utils/getStagePayload';
import { handleGetutm } from '~/utils/handleGetUtm';

const Services: FC<void> = () => {
  const draftQuery = useGetDraft<Draft<'services'>>();
  const applicationQuery = useGetApplication();
  const history = useHistory();

  const data = applicationQuery?.data;
  const stagePayload = getStagePayload.wizard(data);
  const activeStepKey = stagePayload?.activeStep?.key;
  const utmParams = handleGetutm(data);

  useEffect(() => {
    if (applicationQuery.isLoading) return;

    // Backend-driven routing via activeStep.key:
    // If backend says the user should now fill Initial Information → redirect there
    if (activeStepKey === 'initialInformation') {
      history.replace(`${paths.ksa.initialInformation}?${utmParams}`);
      return;
    }

    // If backend says the user is past Initial Information (in application steps) → redirect to Business Info
    if (activeStepKey?.startsWith('application')) {
      history.replace(`${paths.ksa.application}?${utmParams}`);
    }
  }, [activeStepKey, applicationQuery.isLoading]);

  if (draftQuery.isLoading || applicationQuery.isLoading) return <Spin />;

  // Always show Select Products (step 1)
  return <SelectServices setbackToInitial={() => {}} />;
};

export default Services;
